require('../../modules/es6.object.freeze');
module.exports = require('../../modules/$.core').Object.freeze;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/object/freeze.js
// module id = 1874
// module chunks = 14